import { useTranslation } from 'react-i18next'

import { ScannerButton } from '../../common/scanner-button'
import { Loader } from 'src/components/loader'

interface IProps {
  handleDiscard: () => void
  handleNext: () => void
  step: number | null
  canProceed: boolean
  handleDraft: () => void
  proceedShown?: boolean
  draftDisabled?: boolean
  draftLoading?: boolean
  size?: 'small' | 'medium' | 'large'
}

export const Buttons = (props: IProps) => {
  const [t] = useTranslation()

  return (
    <>
      <ScannerButton
        color="dark"
        inline
        text={props.step === 0 ? t('discard-button-text.v') : t('back-button-text.v')}
        onClick={props.handleDiscard}
        size={props.size}
      />
      <ScannerButton
        onClick={props.handleDraft}
        disabled={props.draftDisabled}
        color="light"
        inline
        text={props.draftLoading ? <Loader size={25} /> : t('save-draft-button-text.v')}
        sx={props.size !== 'small' ? { minWidth: '134px' } : {}}
        size={props.size}
      />
      {props.proceedShown && (
        <ScannerButton
          disabled={!props.canProceed}
          onClick={props.handleNext}
          inline
          text={t('proceed-button-text.v')}
          size={props.size}
        />
      )}
    </>
  )
}
